export default "__VITE_ASSET__D2CRreg0__"